import { render, staticRenderFns } from "./ModalDelete.vue?vue&type=template&id=f7410b2c&scoped=true&"
import script from "./ModalDelete.vue?vue&type=script&lang=js&"
export * from "./ModalDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7410b2c",
  null
  
)

export default component.exports